window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let scrollPosition = null;

window.axios.interceptors.request.use(function (config) {
    // Armazene a posição do scroll antes de fazer a requisição
    scrollPosition = window.scrollY;
    return config;
}, function (error) {
    return Promise.reject(error);
});

window.axios.interceptors.response.use(function (response) {
    // Restaure a posição do scroll depois que a resposta for recebida
    if (scrollPosition !== null) {
        window.scrollTo(0, scrollPosition);
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});


// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
